import React from 'react';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import AsyncSelect from 'react-select/async';
import AsyncCreatableSelect from 'react-select/async-creatable';
import classNames from 'classnames';
import { useField } from 'formik';

import Label from '../lib/Label';
import Error from '../lib/Error';
import Container from '../lib/Container';

const CustomOption = (props) => {
    const { innerProps, label, data } = props;
    return (
        <div {...innerProps} className='select-option-item'>
            <div className='option-label'>{label}</div>    
            <div className='option-sublabel'>{data?.sublabel}</div>    
        </div>
    )
}

export default function SelectInput(props) {

    const {
        label,
        name,
        placeholder,
        onChange,
        onCreate,
        readOnly,
        fieldId,
        options,
        loadOptions,
        columns,
        required,
        isMulti,
        isSearchable,
        isClearable,
        formatCreateLabel,
        ignoreCacheOptions,
        phonePrefix,
        ignoreDefaultOptions
    } = props;

    const [field, meta, {setValue}] = useField({
        name,
        readOnly,
        id: fieldId || name
    });

    function onChangeHandler(selected) {

        if (onChange && typeof onChange === 'function') {
            onChange(selected?.value, name)
        }

        return setValue(selected?.value);
    }

    function onCreateHandler(selected) {

        if (onCreate && typeof onCreate === 'function') {
            onCreate(selected, name)
        }

        return setValue(selected);
    }

    const InputClasses = classNames({
        "input-select": true,
        "w-full": true,
        "border-line": true,
        "border-red": meta?.error
    });

    let SelectComponent = Select;
    if(!loadOptions && typeof onCreate === "function") {
        SelectComponent = CreatableSelect;
    }
    if(typeof loadOptions === "function" && !onCreate) {
        SelectComponent = AsyncSelect;
    }
    if(typeof loadOptions === "function" && typeof onCreate === "function") {
        SelectComponent = AsyncCreatableSelect;
    }

    return (
        <Container columns={columns || 1} className={phonePrefix && '!w-120 !min-w-120'}>
            <Label
                label={label}
                name={name}
                fieldId={fieldId}
                focused={true}
                required={required}
            />

            <div className="input-select-container">
                <SelectComponent
                    {...field}
                    value={options?.filter(({value}) => value === field.value)}
                    isMulti={isMulti}
                    isSearchable={isSearchable}
                    isClearable={isClearable}
                    options={options}
                    className={InputClasses}
                    classNamePrefix="select"
                    onChange={onChangeHandler}
                    placeholder={placeholder}
                    loadOptions={loadOptions}
                    formatCreateLabel={formatCreateLabel}
                    onCreateOption={onCreateHandler}
                    components={{Option: CustomOption}}
                    cacheOptions={!ignoreCacheOptions}
                    defaultOptions={!ignoreDefaultOptions}
                />
            </div>

            <Error error={meta?.error}/>
        </Container>
    )
}
